<template>
  <div id="add-contact-l2">
    <section class="toggle-header">
      <div class="input-wrapper position-relative" id="add-as-group">
        <span class="ver-center">Name of Group</span>
        <div class="pl-120">
          <input
            type="text"
            class="mb-0 pb-0 font-16"
            placeholder
            @input="setFirstName($event.target.value)"
            :value="name.firstName"
          />
          <span class="add-client-placeholder float-right">*Add</span>
        </div>
      </div>
      <div class="input-wrapper all-day-wrapper">
        <div class="title-wrapper position-relative">
          <span class="ver-center">Is This a Video Group?</span>
        </div>
        <div class="content-wrapper position-relative checkbox-container">
          <label class="toggle float-right toggle-middle">
            <input
              type="checkbox"
              class="input-btn mb-0 pb-0 font-16"
              value="false"
              :checked="isVideo"
              @change="setIsVideo(!isVideo)"
            />
            <div class="slide-toggle-middle slide-toggle-appoitment"></div>
          </label>
        </div>
      </div>
      <div
        class="input-wrapper position-relative"
        @click.prevent="showSelect = true"
      >
        <span class="ver-center">Group Members</span>
        <div class="pl-120">
          <span class="add-client-placeholder float-right">Add</span>
          <transition name="zoom">
            <multi-select-vue v-if="showSelect" :hide-select="hideSelect" />
          </transition>
        </div>
      </div>
      <div
        class="members-list-wrapper"
        :class="{ border: selected.length > 0 }"
      >
        <members-list-vue />
      </div>

      <div class="btn-wrapper full-width float-left">
        <a
          href="#"
          class="btn-toggle-sumbit buttonstyle"
          @click.prevent="submitFormLocal"
          >Add Group</a
        >
        <a
          href="#"
          class="btn-toggle-sumbit buttonstyle"
          @click.prevent="hideDropDown"
          >Cancel</a
        >
      </div>
    </section>
    <!-- <h1>Name</h1> -->
  </div>
</template>

<script>
import { addNewHomeMixin } from "../../../../mixins/addNewHomeMixin";
import MultiSelectVue from "../../../Group/AddGroup/MultiSelect";
import MembersListVue from "../../../Group/AddGroup/MembersList";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  mixins: [addNewHomeMixin],
  props: {
    hideDropDown: Function
  },
  data() {
    return {
      showSelect: false
    };
  },
  computed: {
    ...mapGetters("addNew", {
      name: "getName"
    }),
    ...mapGetters("group", {
      isVideo: "getIsVideo",
      selected: "getSelected"
    })
  },
  methods: {
    ...mapMutations("addNew", {
      setFirstName: "setFirstName"
    }),
    ...mapMutations("group", {
      setIsVideo: "setIsVideo",
      clearGroup: "clear"
    }),
    ...mapActions("group", {
      submitForm: "submitForm"
    }),
    /**
     * Hide the select bar
     */
    hideSelect() {
      this.showSelect = false;
    },
    /**
     * Submits the form and hides the field
     */
    async submitFormLocal() {
      // Step 1: Submit form
      const res = await this.submitForm();

      // Step 2: Hide the drop down
      if (res) {
        this.hideDropDown();
      }
    }
  },
  components: {
    MultiSelectVue,
    MembersListVue
  },
  destroyed() {
    this.clearState();
    this.clearGroup();
  },
  created() {
    this.clearState();
    this.clearGroup();
  }
};
</script>

<style scoped>
.input-wrapper input {
  border: none !important;
}

div >>> .zoom-enter-active {
  animation: zoomIn 0.2s ease-in-out forwards;
}

div >>> .zoom-leave-active {
  animation: zoomOut 0.2s ease-in-out forwards;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

@keyframes zoomOut {
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
}
</style>
